import React from "react";
import NavBadge from "./NavBadge";

const NavIconButton = ({
  icon: Icon,
  label,
  onClick,
  href,
  badge = 0,
  className = "",
}) => {
  const baseClass = `
    relative inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl
    border border-white/10 bg-white/10 text-white transition
    hover:-translate-y-0.5 hover:bg-white/20 hover:text-orange-200
    focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-300
    sm:h-10 sm:w-10 sm:rounded-2xl
  `;

  if (href) {
    return (
      <a
        href={href}
        title={label}
        aria-label={label}
        className={`${baseClass} ${className}`}
      >
        <Icon className="h-4 w-4" />
        <NavBadge count={badge} />
      </a>
    );
  }

  return (
    <button
      type="button"
      title={label}
      aria-label={label}
      onClick={onClick}
      className={`${baseClass} ${className}`}
    >
      <Icon className="h-4 w-4" />
      <NavBadge count={badge} />
    </button>
  );
};

export default NavIconButton;